(function() {
  const toggle = document.getElementById('lang-toggle');
  const dropdown = document.getElementById('lang-dropdown');
  const picker = document.getElementById('lang-picker');

  if(!toggle || !dropdown || !picker) return;

  console.log('Lang Picker');

  toggle.addEventListener('click', function() {
    dropdown.classList.toggle('hidden');
  });

  document.addEventListener('click', function(event) {
    if(!picker.contains(event.target)) {
      dropdown.classList.add('hidden');
    }
  })

  document.querySelectorAll('.lang-option').forEach(btn => {
    btn.addEventListener('click', function() {
      const code = btn.dataset.langCode;
      const url = new URL(window.location.href);

      url.searchParams.set('lang', code);
      window.location.href = url.toString();
    })
  })
})()
